import React, {useState} from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import RCOptions from 'routes/App/Managers/RefundsCalculator/Components/RCOptions';
import RCReimbursement from 'routes/App/Managers/RefundsCalculator/Components/RCReimbursement';
import {DashboardInner} from 'components/DashboardInner/styles';

import {RCOperationBlock} from 'routes/App/Managers/RefundsCalculator/styles';

const RCOperations = () => {
  const [selectedOperation, setOperation] = useState(null);

  const handleChangeTabs = (event, newValue) => {
    setOperation(newValue);
  };

  return (
    <DashboardInner className='RefundsCalculator withoutShadow'>
      <RCOperationBlock>
        <Tabs
          value={selectedOperation}
          onChange={handleChangeTabs}
          elevation={0}
        >
          <Tab label='User Refund' />
          <Tab label='Restaurant Reimbursement' />
        </Tabs>
      </RCOperationBlock>
      {selectedOperation != null &&
        (selectedOperation === 1 ? <RCReimbursement /> : <RCOptions />)}
    </DashboardInner>
  );
};

export default RCOperations;
